import { PreferredSetting } from '@wilson/interfaces';

export class SetPreferredSetting {
  static readonly type = '[PreferredSettings] Set KPI Setting';
  constructor(
    public userId: string,
    public preferredSetting: PreferredSetting,
  ) {}
}
